import { useCallback } from 'react'
import { useTokenContract } from './useContract'
import { fromWei } from '../utils'

export const usePendingRewards = (
  tokenAddress: string | undefined,
  account: string | null | undefined,
): (() => Promise<number>) => {
  const tokenContract = useTokenContract(tokenAddress)

  const callback = useCallback(async (): Promise<number> => {
    let result = 0
    try {
      if (account && tokenContract) {
        const _balance = await tokenContract.methods.earned(account).call()
        const _balanceBN = fromWei(_balance)
        result = Number(_balanceBN.toFixed(3))
      }
    } catch (error: any) {
      console.error(error)
    }

    return result
  }, [account, tokenContract])

  return callback
}
